import * as React from "react"

export const NoDataMessage = () => {
    return (
        <div className="block">
            <p>No films found</p>
        </div>
    )
}